import { styled } from '@mui/material/styles';
import { Button, Grid, Select, TextField, Typography } from '@mui/material';

const fontSizeSmall = '11.17px';
const lineHeightSmall = '13.61px';
const segmentBorderRadius = '8px';

interface SegmentProps {
  selected: boolean;
}

export const Container = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
`;

export const SegmentContainer = styled(Container)`
  flex-wrap: wrap;
`;

export const StateContainer = styled(Grid)`
  display: flex;
  flex-direction: column;
`;

export const AvailablePacksContainer = styled(Container)`
  width: 100%;
`;

export const Segment = styled(Button)<SegmentProps>`
  background: #f5f5f5;
  color: ${({ selected }) => (selected ? 'red' : '#000')};
  border: ${({ selected }) => (selected ? '1px solid #E81C0E' : '1px solid #f5f5f5')};
  border-radius: ${segmentBorderRadius};
  padding: 6px 9px;
  height: 23.33px;
  position: relative;
  cursor: pointer;
  font-size: 10px;
  font-family: 'Montserrat', sans-serif;

  font-weight: ${({ selected }) => (selected ? '500' : '400')};
  white-space: nowrap;
  transition: background 0.3s, color 0.3s;
  margin-right: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  flex-wrap: wrap;
  width: auto;
  min-width: 0px;

  &:hover {
    background: #e0e0e0;
  }
  margin-bottom: 5px;

  DeselectIcon {
    margin-left: 4px;
    cursor: pointer;
    font-size: 12px;
    line-height: 1;
    color: red;
  }
`;

export const AvailableSegment = styled(Typography)<SegmentProps>`
  color: ${({ selected }) => (selected ? 'red' : '#000')};


  padding: 4px 10px;
  cursor: pointer;
  width: auto;
  font-size: 10.14px;
  transition: background 0.3s, color 0.3s;


  background: white;
  border: ${({ selected }) => (selected ? '1px solid #E81C0E' : '1px solid #f5f5f5')};

  width:35px
  &:hover {
 
  }
`;

export const DeselectIcon = styled('span')`
  top: 0px;
  cursor: pointer;
  color: red;
  margin-left: 3px;
`;

export const SmallTypography = styled('span')`
  font-size: ${fontSizeSmall};
  line-height: ${lineHeightSmall};
  font-family: 'Montserrat', sans-serif;
`;

export const StyledInput = styled(Typography)`
  border: 1px solid #ffeaea;
  border-radius: 4px;
  margin-top: 8px;
  background: #ffeaea;
  border-bottom: 1px solid #ffeaea;
  color: #df2020;
  width: 54.27px;
  height: 22.32px;
  font-size: 10.15px;
  text-align: center;
  padding-top: 4px;
`;

export const PriceTextFieldInput = styled(TextField)(() => ({
  '& .MuiInputBase-input': {
    padding: '0 !important',
    textAlign: 'center',
    background: '#F8F8F8',
    border: '1.01px solid #CACACA',
    color: 'black',
    borderBottom: 'none',
    borderRadius: '3.04px',
    opacity: '70%',
    fontSize: '12px',
    cursor: 'pointer',
    height: '22.32px',
    width: '152px',
    '&:focus': {
      outline: 'none',
      border: '1.01px solid #CACACA',
    },
    '&::placeholder': {
      color: 'inherit',
    },
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      border: '1.01px solid #CACACA',
    },
    '&:hover fieldset': {
      border: '1.01px solid #CACACA',
    },
    '&.Mui-focused fieldset': {
      border: '1.01px solid #CACACA',
    },
  },
}));

export const DistributionSelect = styled(Select)(() => ({
  width: '80px',
  height: '23px',
  '& .MuiOutlinedInput-root': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingRight: '32px',
    '& fieldset': {
      border: '1px solid #CACACA !important',
    },
    '&:hover fieldset': {
      border: '1px solid #CACACA !important',
    },
    '&.Mui-focused fieldset': {
      border: '1px solid #CACACA !important',
    },
    '&.Mui-focused': {
      boxShadow: 'none !important',
      outline: 'none !important',
    },
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: '1px solid #CACACA !important',
  },
  '& .MuiInputBase-root': {
    boxShadow: 'none !important',
    outline: 'none !important',
  },
  '& .MuiSelect-select': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    flexGrow: 1,
    fontSize: '10px',
  },
  '& .MuiSelect-icon': {
    position: 'absolute',
    right: '8px',
    top: '50%',
    transform: 'translateY(-50%)',
    pointerEvents: 'none',
  },
}));
